<template>
  <v-card>
    <v-card-title> </v-card-title>
    <v-data-table
      :headers="headers"
      :items="addresses"
      :items-per-page="25"
      class="elevation-1"
      v-if="addresses"
    >
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "dataTableStudentAddresses",

  data: () => ({
    drawer: null,
    headers: [
      { text: "Type", value: "type" },
      { text: "Prénom", value: "edges.contacts.first_name" },
      { text: "Nom", value: "edges.contacts.last_name" },
      { text: "Email", value: "edges.contacts.email" },
      { text: "Adresse", value: "edges.contacts.address" },
      { text: "Ville", value: "edges.contacts.city" },
      { text: "CP", value: "edges.contacts.zip_code" },
      { text: "Pays", value: "edges.contacts.country_iso2" },
    ],
    addresses: null,
  }),
  mounted() {
    this.axios
      .get("/student/" + this.$route.params.id + "/addresses")
      .then((response) => (this.addresses = response["data"]));
  },
};
</script>